import { ApolloProvider } from '@apollo/client';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import { apolloClientFactory, defaultCache } from '@eluve/apollo-client';
import { LoadingIndicator } from '@eluve/components';
import { ArtifactDetailsPage } from '@eluve/frontend-feature-eval';

import { appConfig } from '../../../config';
import { tokenProvider } from '../../../session-token-provider';

import { EvalGuard } from './EvalGuard';
import { EvalLayout } from './EvalLayout';
import { SourceArtifactPendingReviewListPage } from './SourceArtifactPendingReviewListPage';

const evalApolloClient = apolloClientFactory({
  uri: appConfig.VITE_APOLLO_CLIENT_URI,
  desiredRole: 'eval-user',
  cacheInstance: defaultCache,
  accessTokenProvider: tokenProvider,
});

export const createEvalRoutes = (path: string) => {
  return [
    {
      path,
      element: (
        <Suspense fallback={<LoadingIndicator size="xl" />}>
          <EvalGuard>
            <Helmet>
              <title>Eval | Eluve</title>
            </Helmet>
            <ApolloProvider client={evalApolloClient}>
              <EvalLayout />
            </ApolloProvider>
          </EvalGuard>
        </Suspense>
      ),
      children: [
        {
          path: 'source-artifact-review',
          element: <SourceArtifactPendingReviewListPage />,
        },
        {
          path: 'source-artifact-review/:artifactId',
          element: <ArtifactDetailsPage />,
        },
      ],
    },
  ];
};
